import React from "react";

function Breadcrumb(props) {
  return (
    <section
      className="banner page-banner position-relative pb-0"
      style={{
        backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/breadcrumb_banner.png')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        overflow: "hidden",
      }}
    >
      <div className="overlay"></div>

      {/* 🔥 Animated Chart */}
      <svg className="chart-svg" viewBox="0 0 800 300">
        <path
          className="chart-line"
          d="M0,250 L100,220 L200,240 L300,180 L400,200 L500,140 L600,160 L700,100 L800,60"
        />
      </svg>

      <div className="container">
        <div className="page-title text-center position-relative py-11">
          <h2 className="text-white text-uppercase">{props.title}</h2>
          <p className="text-white">{props.subtitle}</p>
        </div>
      </div>
    </section>
  );
}

export default Breadcrumb;
